
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#748190","stroke-width":"1.714","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_595_31204)"}},[_c('path',{attrs:{"d":"M12.856 4.072H4.285c-.789 0-1.429.64-1.429 1.43v12.856c0 .79.64 1.429 1.429 1.429h8.571c.79 0 1.429-.64 1.429-1.429V5.501c0-.789-.64-1.429-1.429-1.429zM5.714 7.644h5.714M5.714 11.215h5.714M5.714 14.787H8.57"}}),_c('path',{attrs:{"d":"M6.43 1.215h9.285a1.429 1.429 0 011.429 1.429v13.571"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_595_31204"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    